import { flexbox } from "@material-ui/system";

export const styles = () => ({
  buttonClass: {
    border: "1px solid #999999",
    marginRight: 12,
    cursor: "pointer",
    "&:hover": {
      border: "1px solid #26bbed",
    },
    "&:hover div": {
      color: "#26bbed",
    },
  },
  buttonContent: {
    padding: "5px 12px",
    color: "black",
    fontSize: 14,
    display: "flex"

  },
  iconClass: {
    padding: 2,
    paddingLeft: 7,

  },
  list: {
    height: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "white",
    padding: "8px 10px",
    minWidth: 154,
    fontSize: 16,
    cursor: "pointer"
  },
  paper: {
    backgroundColor: "white",
    top: "120px !important",
    boxShadow: "5px 5px 20px rgba(0, 0, 0, 0.06)",
    borderRadius: 2,
    border: "1px solid #DADADA",
    padding: "4px 0px",
  },
  hover: {
    "&:hover": {
      color: "#26BBED"
    }
  },
  checkIconStyle: {
    color: "#26BBED"
  }
})